
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onUnmounted
} from "vue";
import NativeClient from "@/client/native-client";
import store from "@/store";
import router from "@/router";
import {
  PANTRY_FOOD_TYPE,
  PANTRY_RECIPE_TYPE,
  RequestRecommendRecipe,
  RecipeFoodsData,
  FoodBanner,
  RequestFavoriteFood,
  RequestShoppingFood,
  RequestShoppingFoods
} from "@/types/pantry";
import {
  createRecipeToCommonRecipes
} from "@/utils/search-util";
import PantryPRFoodView from "@/components/pantry/PantryPRFoodView.vue";
import PantryRecommendView from "@/components/pantry/PantryRecommendView.vue";
import PantryRecommendTitle from "@/components/pantry/PantryRecommendTitle.vue";
import CommonDesignDialog from "@/components/common/CommonDesignDialog.vue";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import PantryRecommendMainView from "@/components/pantry/PantryRecommendMainView.vue";
export default defineComponent({
  name: "PantryPRFoodPage",
  components: {
    PantryPRFoodView,
    PantryRecommendView,
    PantryRecommendTitle,
    CommonDesignDialog,
    PantryRecommendMainView
  },
  setup() {
    const ERROR_BUTTON_LABEL = "OK";
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();
    const { closeDialog } = useApiErrorDialog();
    const getFoodId = () => {
      const id = Number(router.currentRoute.value.query.foodId);
      NativeClient.sendDebugLog("getFoodId id=" + id);
      let result = -1;
      if (isNaN(id)) {
        NativeClient.sendDebugLog("getFoodId empty");
      } else {
        result = id;
      }
      return result;
    };
    const foodId = getFoodId();
    const recipeFoodsData = ref(new RecipeFoodsData(null));
    const favoriteStatus = ref(false);
    const isShowRecommend = ref(false);
    const updateRecipeFoodsKey = ref(0);
    const updateRecipeFoods = () => {
      if (updateRecipeFoodsKey.value >= 100) {
        updateRecipeFoodsKey.value = 0;
      } else {
        updateRecipeFoodsKey.value++;
      }
    };
    NativeClient.sendDebugLog("PantryPRFoodPage foodId=" + foodId);
    NativeClient.showCloseButton(true);
    const requnstFavorite = async () => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const webApiList = new Array<any>();
        const payload = new RequestFavoriteFood(foodId);
        const favorite = !favoriteStatus.value;
        if (favorite) {
          webApiList.push(store.dispatch("pantry/addFavoriteFood", payload));
        } else {
          webApiList.push(store.dispatch("pantry/removeFavoriteFood", payload));
        }
        Promise.all(webApiList).then(result => {
          favoriteStatus.value = favorite;
          NativeClient.requestReloadFavoriteFood();
          store.dispatch("common/stopLoading");
        });
      });
    };
    const requestShoppingIngredients = async (shoppingFoods: RequestShoppingFoods) => {
      store.dispatch("common/startLoading");
      const apiBaseParams = store.getters["common/getApiBaseParams"];
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([store.dispatch("pantry/registerShoppingFoods", shoppingFoods)]).then(
          result => {
            store.dispatch("common/stopLoading");
          }
        );
      });
    };
    const requnstShoppingList = async () => {
      NativeClient.sendDebugLog(
        "PantryPRFoodPage requnstShoppingList recipeFoodsData=" + JSON.stringify(recipeFoodsData.value)
      );
      if (recipeFoodsData.value == null || recipeFoodsData.value.foodItem == null) {
        return;
      }
      const name = recipeFoodsData.value.foodItem?.name;
      const shoppingFood = new RequestShoppingFood(foodId, name);
      const shoppingFoods = new RequestShoppingFoods();
      shoppingFoods.foods.push(shoppingFood);
      requestShoppingIngredients(shoppingFoods);
    };
    const getRecipeFoods = () => {
      const result = store.getters["pantry/getRecipeFoods"];
      const resultFavorite = store.getters["pantry/getFavoriteFood"];
      NativeClient.sendDebugLog(
        "PantryPRFoodPage getRecipeFoods result=" + JSON.stringify(result)
      );
      NativeClient.sendDebugLog(
        "PantryPRFoodPage getRecipeFoods resultFavorite=" + JSON.stringify(resultFavorite)
      );
      if (result != null && result.foods != null && result.foods.length >= 1) {
        recipeFoodsData.value.foodItem = result.foods[0];
        NativeClient.sendDebugLog(
          "PantryPRFoodPage getRecipeFoods foodItem=" + JSON.stringify(recipeFoodsData.value.foodItem)
        );
        updateRecipeFoods();
      }
      if (resultFavorite != null) {
        favoriteStatus.value = resultFavorite.done;
      }
    };
    const requestRecommendRecipe = async () => {
      NativeClient.sendDebugLog("PantryPRFoodPage requestRecommendRecipe foodId=" + foodId);
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiParams = store.getters["common/getApiBaseParams"];
        NativeClient.sendDebugLog(
          "PantryPRFoodPage getRecipes apiParams=" + JSON.stringify(apiParams)
        );
        const payload = new RequestRecommendRecipe(null, foodId);
        const favoritePayload = new RequestFavoriteFood(foodId);
        Promise.all([
          store.dispatch("pantry/getRecommendRecipe", payload),
          store.dispatch("pantry/getSearchFood", payload),
          store.dispatch("pantry/getFavoriteFood", favoritePayload)
        ]).then(result => {
          getRecipeFoods();
          store.dispatch("common/stopLoading");
        });
      });
    };
    const recommendRecipes = computed(() => {
      const result = store.getters["pantry/getRecommendRecipes"];
      NativeClient.sendDebugLog(
        "PantryPRFoodPage recommendRecipes result=" + JSON.stringify(result)
      );
      if (result != null && result.recipes != null) {
        const commonRecipe = createRecipeToCommonRecipes(result.recipes);
        return commonRecipe;
      }
      return null;
    });
    const requestFood = async () => {
      NativeClient.sendDebugLog(
        "PantryPRFoodPage requestFood foodId=" + foodId
      );
      requestRecommendRecipe();
    };
    const favoriteImage = computed(() => {
      return favoriteStatus.value
        ? require("@/assets/images/icon_pantry_favorite_on.png")
        : require("@/assets/images/icon_pantry_favorite_off.png");
    });
    const execute = async () => {
      requestFood();
    };

    const isShowRecommendList = () => {
      return (recommendRecipes.value && recommendRecipes.value.length >= 1);
    };

    const onSelectBanner = (link: string) => {
      NativeClient.sendDebugLog(
        "PantryPRFoodPage onSelectBanner link=" + link
      );
      const url = link + "?window=browser";
      NativeClient.sendDebugLog(
        "PantryPRFoodPage onSelectBanner url=" + url
      );
      location.href = url;
    };
    const onClickFavrite = () => {
      requnstFavorite();
    };
    const onClickShopList = () => {
      requnstShoppingList();
    };
    const clickSeeMore = (type: string) => {
      NativeClient.sendDebugLog("PantryPRFoodPage clickSeeMore type=" + type);
      switch (type) {
        case PANTRY_RECIPE_TYPE.RECOMMEND:
          isShowRecommend.value = true;
          NativeClient.showCloseButton(false);
          break;
      }
    };
    const onCloseRecommend = () => {
      isShowRecommend.value = false;
      NativeClient.showCloseButton(true);
    };
    const onSelectRecipe = (id: number, type: string) => {
      // Native側にレシピ詳細画面に遷移指示を出す
      NativeClient.sendDebugLog(
        "PantryPRFoodPage selectRecipe id=" + id + " type=" + type
      );
      NativeClient.transitionReceipDetail(id, type);
    };
    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      store.dispatch("pantry/updateRecommendRecipe", null);
      execute();
    });
    /**
     * コンポーネントがマウントされたときに通知される
     */
    onUnmounted(async () => {
      // 画面から離れた場合
    });
    const closeError = () => {
      closeDialog();
    };
    return {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      recommendRecipes,
      PANTRY_FOOD_TYPE,
      PANTRY_RECIPE_TYPE,
      isShowRecommendList,
      updateRecipeFoodsKey,
      recipeFoodsData,
      onSelectBanner,
      favoriteImage,
      onClickFavrite,
      onClickShopList,
      clickSeeMore,
      onCloseRecommend,
      onSelectRecipe,
      isShowRecommend,
      closeError,
      ERROR_BUTTON_LABEL
    }
  }
});
